import { Postagem } from "./Postagem"

export class Tema {
    public id: number
    public descricao: string
    public Postagem: Postagem[]
}